import Styled from 'styled-components';
import { respondTo } from '../../../respondTo';


export const FreeTrialContainer = Styled.div`
        width: 100%;
        background-color: var(--inverse-on-surface-light);
        display: "flex";
        align-items: "center";
        justify-content: "center";
        padding: 2.5rem 1.25rem ;
        text-align: center;

        ${respondTo.desktop`
            padding: 3.75rem 2.5rem 2.5rem ;
            `}
        ${respondTo.desktop_xl`
            padding: 3.75rem 4.375rem 2.5rem ;
            `}
     
`
      
export const FreeTrialBox = Styled.div`
    display: flex;
    background-color: var(--on-primary-container-dark),
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
`
export const FlagText = Styled.p`
    color: var(--on-surface-light);
    padding: 1.25rem 2.5rem ;
    width: 100%;
    `
export const FreeTrialText = Styled.p`
        padding: 0 0 1.25rem;
        text-align: center;

            ${respondTo.desktop`
             margin: 0 0 0.625rem;
     `}

    ${respondTo.desktop_xl`
        margin: 0 0 1.25rem;
    `}
   
    `

